'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function stubArray() {
    return [];
}

exports.stubArray = stubArray;
